export default __webpack_public_path__ + "static/media/zoom-logo-png.e98257dd.webp";